export function checkDoesTagExistInResults(query, results) {
  if (!results) return false;
  if (!query) return false;

  let has = false;
  results.forEach((r) => {
    if (r.name.toLowerCase() === query.toLowerCase().trim()) {
      has = true;
    }
  });
  return has;
}

export function formatTagResponseData(data) {
  return {
    ...data,
    id: data.doc_tag_id || data.id,
  };
}
